import styled from 'styled-components'
import {
  ReadingGuideInfoSwitchButtonContainer,
  ReadingGuideInfoSwitchButton,
  ReadingGuideInfoTitle,
  ReadingGuideInfoBody,
  SectionOrganizationBodyEntry,
} from '../../../readingGuides/state-and-styles/readingGuideStyles'

export const EssayInfoSwitchButtonContainer = styled(
  ReadingGuideInfoSwitchButtonContainer,
)``

export const EssayInfoSwitchButton = styled(ReadingGuideInfoSwitchButton)`
  font-size: 2vh;
  width: 80%;
`

export const EssayInfoTitle = styled(ReadingGuideInfoTitle)``

export const EssayInfoBody = styled(ReadingGuideInfoBody)``

export const EssaySectionOrganizationBodyEntry = styled(
  SectionOrganizationBodyEntry,
)`
  padding-bottom: 10%;
`
